import React from 'react';
import { useReducedMotion } from 'framer-motion';

const TYPE_SPEED = 65;
const DELETE_SPEED = 35;
const HOLD_TIME = 2200;

const TypeCycle = ({ roles, className }) => {
  const prefersReducedMotion = useReducedMotion();
  const [roleIndex, setRoleIndex] = React.useState(0);
  const [length, setLength] = React.useState(0);
  const [deleting, setDeleting] = React.useState(false);
  const role = roles[roleIndex];

  React.useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }
    let timer;

    if (!deleting && length < role.length) {
      timer = setTimeout(() => setLength((l) => l + 1), TYPE_SPEED);
    } else if (!deleting && length === role.length) {
      timer = setTimeout(() => setDeleting(true), HOLD_TIME);
    } else if (deleting && length > 0) {
      timer = setTimeout(() => setLength((l) => l - 1), DELETE_SPEED);
    } else {
      setDeleting(false);
      setRoleIndex((i) => (i + 1) % roles.length);
    }

    return () => clearTimeout(timer);
  }, [length, deleting, role, roles, prefersReducedMotion]);

  const text = prefersReducedMotion ? roles[0] : role.slice(0, length);

  return (
    <p className={className}>
      <span className="type-cycle-arrow" aria-hidden="true">&gt;</span> {text}
      {!prefersReducedMotion && <span className="terminal-cursor" aria-hidden="true">▌</span>}
    </p>
  );
};

export default TypeCycle;
